import React from "react";
import AuthPageV2 from "./auth/AuthPageV2";

const SignupPage: React.FC = () => <AuthPageV2 mode="signup" />;

export default SignupPage;
